export default __webpack_public_path__ + "static/media/badges.59b899fe.jpg";